import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Row, Col } from 'styled-bootstrap-grid'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { Button } from 'components/UI/Button'
import { ContentBlock } from 'components/common'
import { logout } from 'ducks/auth/operations'
import { Label, RightHeadTitle, Value, HeadTitle } from './styles'
import { Table } from '../../components/UI/CompactTable'
import { formatDateToString } from '../../utils/dateFormats'
import {
  deleteUser,
  fetchPatient,
  fetchPatientsEstimations,
  resetUserPassword
} from '../../ducks/patients/operations'
import { history, routePath } from '../../routes'
import { Modal } from '../../components/UI/Modal'

interface State {
  user: any
  showModal: boolean
  isDelete: boolean
}

class PatientDetailPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      user: {},
      showModal: false,
      isDelete: false
    }
  }
  componentDidMount(): void {
    const {
      match: {
        params: { id }
      }
    } = this.props
    this.props.fetchPatient(id)
    this.props.fetchPatientsEstimations(id)
  }
  noItems = () => (
    <TextBlock>
      <p>Patient don’t have any estimates.</p>
    </TextBlock>
  )
  fetchDeleteUser = () => {
    const {
      deleteUser: DU,
      match: {
        params: { id }
      }
    } = this.props
    history.push(routePath.PATIENTS_LIST)
    DU(id)
    this.setState({ showModal: false })
  }
  onCloseModal = () => {
    this.setState({ showModal: false })
  }
  deleteUser = () => {
    this.setState({ showModal: true, isDelete: true })
  }
  resetPassword = () => {
    this.setState({ showModal: true, isDelete: false })
  }
  fetchResetPassword = () => {
    const {
      resetUserPassword: RUP,
      match: {
        params: { id }
      }
    } = this.props
    history.push(routePath.PATIENTS_LIST)
    RUP(id)
    this.setState({ showModal: false })
  }
  render() {
    const { patient, estimations } = this.props
    const { showModal, isDelete } = this.state
    const getTableBody = (estimatesList: any[] | undefined) => {
      if (estimatesList) {
        return estimatesList.map((row: any, i) => {
          const procedureName = row.appointmentTypeEntityList.map(
            (item: any) => {
              return item.appointmentCode + ' ' + item.description
            }
          )
          const cpt4Name = row.cpt4EntitySet.map((item: any) => {
            return item.cpt4Code + ' ' + item.description
          })
          const viewProcedureName =
            procedureName.length === 1
              ? procedureName[0]
              : procedureName.join(',')

          const viewCpt4Name =
            cpt4Name.length === 1 ? cpt4Name[0] : cpt4Name.join(',')

          return {
            id: row.id,
            columns: [
              formatDateToString(row.createdAt),
              `${row.firstName} ${row.lastName}`,
              !viewCpt4Name ? viewProcedureName : viewCpt4Name,
              '',
              `${row.patientResponsibility ? row.patientResponsibility : '-'}`
            ]
          }
        })
      }
      return []
    }
    const headers = {
      columns: [
        { name: 'Date Created' },
        { name: 'User Name' },
        { name: 'Procedure Name' },
        { name: 'User Responsibility' }
      ]
    }

    const {
      firstName,
      lastName,
      memberId,
      mobileNumber,
      email,
      gender,
      dob
    } = patient
    const fullName = firstName && lastName ? firstName + ' ' + lastName : '-'
    const renderCol = (label: string, value: string) => {
      if (label === 'DOB') {
        const oldDate = value.split('-')
        const [y, m, d] = oldDate
        const newDate = [m, d, y]
        return (
          <Col xl={4} md={6}>
            <Option>
              <Label>{label}</Label>
              <Value>
                {newDate.join('/') === '//' ? '-' : newDate.join('/')}
              </Value>
            </Option>
          </Col>
        )
      }
      return (
        <Col xl={4} md={6}>
          <Option>
            <Label>{label}</Label>
            <Value>{value}</Value>
          </Option>
        </Col>
      )
    }
    return (
      <WrapBlock>
        <HeadTitle>
          <h1>{fullName}</h1>
          <RightHeadTitle>
            <LinkDelete onClick={this.deleteUser}>Delete</LinkDelete>
            <Button variant={'text'} onClick={this.resetPassword}>
              Reset Password
            </Button>
          </RightHeadTitle>
        </HeadTitle>

        <ContentBlock isCentered={false}>
          <Row>
            {renderCol('Name', fullName)}
            {renderCol('Member ID', memberId ? memberId : '-')}
            {renderCol('Number', mobileNumber ? mobileNumber : '-')}
            {renderCol('Email', email ? email : '-')}
            {renderCol('Gender', gender ? gender : '-')}
            {renderCol('DOB', dob ? dob : '-')}
          </Row>
        </ContentBlock>
        {getTableBody(estimations).length === 0 ? (
          <ContentBlock isCentered={true}>{this.noItems()}</ContentBlock>
        ) : (
          <Table
            header={headers}
            body={getTableBody(estimations)}
            // isEstimate={true}
            goTo={(id, isNew) => `/estimate/${id}/${isNew}`}
            // actionBlock={actionBlock}
          />
        )}
        {console.log(getTableBody(estimations))}
        <Modal
          modal={{
            title: isDelete ? 'Are you want to delete?' : 'Reset Password',
            content: (
              <div>
                <Text>{fullName}</Text>
              </div>
            ),
            footer: (
              <Fragment>
                {isDelete ? (
                  <Fragment>
                    <Button variant={'text'} onClick={this.onCloseModal}>
                      Cancel
                    </Button>
                    <Button
                      variant={'text-danger'}
                      onClick={this.fetchDeleteUser}
                    >
                      Delete
                    </Button>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Button variant={'text'} onClick={this.onCloseModal}>
                      Cancel
                    </Button>
                    <Button variant={'text'} onClick={this.fetchResetPassword}>
                      Reset
                    </Button>
                  </Fragment>
                )}
              </Fragment>
            )
          }}
          isOpen={showModal}
        />
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps &
  DispatchProps &
  ReceivedProps &
  RouteComponentProps<any>

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  patient: state.patients.patientDetailData.patient,
  estimations: state.patients.patientDetailData.estimations
    ? state.patients.patientDetailData.estimations.content
    : []
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      logout,
      fetchPatient,
      fetchPatientsEstimations,
      deleteUser,
      resetUserPassword
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientDetailPage)

export const Comment = styled.div`
  font-size: 15px;
  color: #89919c;
`

export const WrapBlock = styled.div``

export const Option = styled.div`
  margin-bottom: 2rem;
`
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: #152735;
    margin-bottom: 1.5rem;
  }
`
const LinkDelete = styled.span`
  text-decoration: none;
  font-size: 16px;
  color: #d82c2c;
  font-weight: bold;
  cursor: pointer;
  margin-top: 14px;
`
const Text = styled.span`
  text-decoration: none;
  font-size: 16px;
  color: #152735;
  font-weight: bold;
  cursor: pointer;
  margin-top: 14px;
`
